import React, { Component } from 'react'

// TODO: Temporary to handle Safari breaking on drawer closer
class ErrorBoundary extends Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = { fallback: false }
  }

  componentDidCatch(error: any, info: any) {
    this.setState({ fallback: true })
  }

  render() {
    if (this.state.fallback) {
      return <></>
    }
    return this.props.children
  }
}

export default ErrorBoundary
